/**
 * 5.0.8.1 Profile - Enterprise Admin - Forum Membership
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=3247%3A5776
 */
// @react
import React from 'react'
// @design
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  root: {},
})

const ForumMembership = () => {
  const classes = useStyles()

  /**
   * props
   */
  return <div className={classes.root}>Forum Membership</div>
}

export default ForumMembership
